/**
 * تصغيرُ ملفِّ صورةٍ إلى حدٍّ أقصى لبُعده — بحفظِ نسبته — كـ data URL.
 *
 * يُستعمل لحفظ «الأصل» المرفوع بحجمٍ معقولٍ (لا الميجابايتات الكاملة) كي
 * يُعاد ضبطُ قصِّه لاحقًا بحرّيّةٍ دون رفعٍ ثانٍ. `canvas` بلا مكتبة.
 */
export async function downscaleFile(
  file: File,
  maxDim: number,
  quality = 0.85,
): Promise<string> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('no 2d context');
    ctx.drawImage(bitmap, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg', quality);
  } finally {
    bitmap.close();
  }
}
